module.exports = __webpack_public_path__ + "img/hr-level3addon_idle_gun_mask.d4a6286b.png";